import { PaginatedData } from '@base/wrappers/paginated-data';
import { UseCase } from '@domain/base/use-case';
import { AdvancesAvailableModel } from '@domain/models/advance-available.model';
import { CatalogRepository } from '@domain/repositories/catalog.repository';
import { Observable } from 'rxjs';

export class GetCatalogAdvancesAvailableUseCase
  implements UseCase<{pageNumber?: number; pageSize?: number; savingsPlanId :string}, PaginatedData<AdvancesAvailableModel>>
{
  constructor(private catalogRepository: CatalogRepository) {}

  execute(
    params : {pageNumber?: number, pageSize?: number, savingsPlanId :string}
  ): Observable<PaginatedData<AdvancesAvailableModel>> {
    return this.catalogRepository.getCataloAdvancesAvailable(params.pageNumber ?? 1,
      params.pageSize ?? 100,params.savingsPlanId);
  }
}
